var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMenuIconClose(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 16,
    viewBox: "0 0 15 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.342223 1.15826C0.79852 0.701966 1.53769 0.701966 1.99399 1.15826L7.5 6.66428L13.006 1.15826C13.4623 0.701966 14.2015 0.701966 14.6578 1.15826C15.1141 1.61456 15.1141 2.35373 14.6578 2.81003L9.15176 8.31604L14.6578 13.8221C15.1141 14.2783 15.1141 15.0175 14.6578 15.4738C14.2015 15.9301 13.4623 15.9301 13.006 15.4738L7.5 9.9678L1.99399 15.4738C1.53769 15.9301 0.79852 15.9301 0.342223 15.4738C-0.114074 15.0175 -0.114074 14.2783 0.342223 13.8221L5.84824 8.31604L0.342223 2.81003C-0.114074 2.35373 -0.114074 1.61456 0.342223 1.15826Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenuIconClose);
export default __webpack_public_path__ + "static/media/menuIconClose.476d0564.svg";
export { ForwardRef as ReactComponent };